






















































import { Component, Prop } from "vue-property-decorator";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { UserAdministrationModule } from "@/store/modules/admin-user.store";
import { simpleDate } from "@/lib/utility/date-helper";
import UserAdministrationDetailCreateDialog from "@/components/partner/UserAdministrationDetailCreateDialog.vue";
import Vue from "vue";
import FilterCard from "@/components/filter/FilterCard.vue";
import { getDateFilterList } from "@/lib/utility/filter";
import { AssetRepository, AssetEnum } from "@/lib/AssetRepository";
import { UserEntity } from "@/models/userEntity";

@Component({ components: { UserAdministrationDetailCreateDialog, FilterCard } })
export default class UserAdministrationList extends DarkModeHighlightMixin {
  @Prop({ default: false })
  loading!: boolean;

  search = "";
  selected: UserEntity = UserAdministrationModule.selectedUser;

  get users() {
    return UserAdministrationModule.users;
  }

  isActive(item: UserEntity) {
    return item._id === UserAdministrationModule.selectedUser._id ? "v-item--active v-list-item--active" : "";
  }

  date(item: UserEntity): string {
    if (item.timestamps) {
      return simpleDate(item.timestamps?.created);
    }

    return "";
  }

  isLoadingUser(status: boolean) {
    this.$emit("isLoadingUser", status);
  }

  refresh() {
    this.$emit("refresh");
  }

  async set(item: UserEntity) {
    this.isLoadingUser(true);
    if (["xs", "sm"].includes(this.$vuetify.breakpoint.name)) {
      this.$router.push({ name: "UserAdministrationDetail", params: { userId: item._id } });
    } else {
      const user = await UserAdministrationModule.getSelectedUser(item._id);
      if (!user) {
        Vue.$toast.error("Der Ausgewählte Nutzer konnte nicht geladen werden.");
      }
    }
    this.isLoadingUser(false);
  }

  get emptyDataSrc() {
    return AssetRepository.getAsset(false, AssetEnum.emptyData);
  }

  /**
   * The available categories visible in the filter menu
   */
  filterList = getDateFilterList("timestamps");

  items = UserAdministrationModule.users.slice();

  get filteredItems() {
    return this.items;
  }
}
